import { Layout } from 'antd';
import styled from 'styled-components';

export const StyledHeader = styled(Layout.Header)`
  background-color: ${({ theme }) => theme.color.grey.grey11};
  height: 48px;
`;
